angular.module('aprima-provider-api').factory('SigWriterRepository',
    ['AprimaRestangular', 'AprimaAnalytics', 'MetadataRepository',
        function (AprimaRestangular, AprimaAnalytics, MetadataRepository) {
            'use strict';

            return {
                checkIsSpecialtyId: checkIsSpecialtyId,
                getDirectionsSettings: getDirectionsSettings,
                getDrugCptList: getDrugCptList,
                getDrugSettings: getDrugSettings,
                initializeDefaultSig: initializeDefaultSig,
                saveDefaultSig: saveDefaultSig,
                getDefaultSigMetadata: getDefaultSigMetadata,
            };

            function checkIsSpecialtyId(ndc, rxnorm, providerId) {
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'checkIsSpecialtyId');
                return AprimaRestangular.get()
                    .one('drugs/specialty/' + ndc + '/' + rxnorm + '/id/' + providerId)
                    .get()
                    .finally(timing.stop);
            }

            function getDirectionsSettings(drug, providerId, sigType, visitId, checkIsSpecialtyMedication) {
                var restangular = AprimaRestangular.get();
                var request = {
                    Drug: drug,
                    ProviderId: providerId,
                    SigType: sigType,
                    VisitId: visitId,
                    CheckIsSpecialtyMedication: checkIsSpecialtyMedication
                };
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'getDirectionsSettings');
                return restangular
                    .all('sigwriter/' + providerId + '/directions-settings')
                    .post(request)
                    .finally(timing.stop);
            }

            function getDrugCptList(medid) {
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'getDrugCptList');
                var restangular = AprimaRestangular.get();
                return restangular.all('sigwriter/drugcptlist/' + medid)
                                  .getList()
                                  .finally(timing.stop());
            }

            function getDrugSettings(sigType, drug, providerId, patientId, visitId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var restangular = AprimaRestangular.get(restangularOptions);
                var request = {
                    Drug: drug,
                    PatientId: patientId,
                    SigType: sigType,
                    VisitId: visitId,
                };
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'getDrugSettings');
                return restangular
                    .all('sigwriter/' + providerId + '/drug-settings')
                    .post(request)
                    .finally(timing.stop);

                /*
                var promise = restangular
                    .all('sigwriter/' + providerId + '/drug-settings')
                    .post(request)
                    .finally(timing.stop);
                return promise;
                */
            }

            function initializeDefaultSig(currentRx, providerDefaultSigId, restangularOptions){

                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'initialize default sig');
                var restangular = AprimaRestangular.get(restangularOptions);
                var params = (providerDefaultSigId) ? '/' + providerDefaultSigId : '';
                return restangular.all('fnc/rx/initialize-default-sig' + params).post(currentRx).finally(timing.stop);
            }

            function saveDefaultSig(createModifyDefaultSigDto, restangularOptions){

                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'save default sig');
                var restangular = AprimaRestangular.get(restangularOptions);
                var params = (createModifyDefaultSigDto.ProviderDefaultSigId) ? '/' + createModifyDefaultSigDto.ProviderDefaultSigId : '';
                return restangular.all('fnc/rx/default-sig' + params).post(createModifyDefaultSigDto).finally(timing.stop);
            }

            function getDefaultSigMetadata ($scope) {
                var timing = AprimaAnalytics.startTiming('SigWriterRepository', 'api', 'getDefaultSigMetadata');
                return MetadataRepository.getMetadata('fnc/rx/new-default-sig', $scope).finally(timing.stop);
            }
       }]);